import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StockCategoryFilter, getCategoryConfigs } from '../../types/stockCategories';
import { cn } from '../../utils/cn';

interface ArchiveButtonProps {
  category: StockCategoryFilter;
  className?: string;
}

export const ArchiveButton: React.FC<ArchiveButtonProps> = ({ category, className }) => {
  const navigate = useNavigate();
  const config = getCategoryConfigs()[category];

  return (
    <button
      type="button"
      onClick={() => navigate(`/${category}/archive`)}
      className={cn(
        'group w-full rounded-lg px-4 py-2 text-xs font-bold tracking-wide text-white transition-colors',
        className
      )}
      style={{ backgroundColor: config.color }}
    >
      Play Past {config.icon} {config.label} Games <span className="inline-block transition-transform group-hover:translate-x-1">&rarr;</span>
    </button>
  );
};
